import { Chat as ChatIcon, Close as CloseIcon } from "@mui/icons-material";
import { Box, Drawer, IconButton, Stack, Typography } from "@mui/material";

import { Chat } from "../Chat/Chat";

interface ChatSlideoutProps {
  open: boolean;
  onClose: () => void;
  roomId?: string;
  eventId?: string;
  memberCount?: number;
}

export const ChatSlideout = ({ open, onClose, roomId, eventId, memberCount = 0 }: ChatSlideoutProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          borderRadius: "16px 0 0 16px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          width: { sm: 400, xs: "100%" },
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {/* Header */}
        <Box
          sx={{
            alignItems: "center",
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            p: 3,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <ChatIcon sx={{ fontSize: "2rem" }} />
            <Box>
              <Typography variant="h5" fontWeight="bold">
                Chat
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {memberCount === 1 ? "1 person online" : `${memberCount} people online`}
              </Typography>
            </Box>
          </Stack>
          <IconButton
            onClick={onClose}
            sx={{
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Chat Content */}
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <Chat roomId={roomId} eventId={eventId} />
        </Box>
      </Box>
    </Drawer>
  );
};
